cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label
    },

    ctor () {
        this.time = -1; //seconds
    },

    set (time) {
        if (time) {
            // convert ms to sec
            this.time = time / 1000;
            this.tick();
        }
    },

    tick() {
        if (this.time < 0 ) {
            return;
        }
        this.time ++;
        this.label.string = this._format(this.time);
    },

    _format(d) {
        d = Number(d);
        const h = Math.floor(d / 3600);
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? this._filterDigit(h) + ':' : '';
        var mDisplay = m > 0 ? this._filterDigit(m) + ':' : '00:';
        var sDisplay = s > 0 ? this._filterDigit(s) : '00';
        return hDisplay + mDisplay + sDisplay;
    },

    _filterDigit (d) {
        d = d.toString();
        if (d.length === 1) {
            return '0' + d
        }
        return d;
    }
});

